module.exports = __webpack_public_path__ + "img/google_signin_button.3a33ebe2.png";